import React from 'react';
import useNavigationLogic from '../../Hooks/useNavigationLogic';

function NextButton({ buttontext = "Next", stylename = "", beforeNavFunc, validationFunc, state, disabled }) {
    const navigateToNextPage = useNavigationLogic(beforeNavFunc, validationFunc, state);

    return (
        <button onClick={navigateToNextPage} disabled={disabled} className={stylename}>
            {buttontext}
        </button>
    );
}

export default NextButton;
